import { useEffect, useState } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { useHistory, Redirect } from "react-router-dom";
import { ChevronLeft } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import HomeLayout from '../../components/HomeLayout';
import { ANALYTICS_DASHBOARD_URL, SQUARE_SIGNUP_URL } from "../../const/URL.const";
import EmailVerificationMessage from './EmailVerificationMessage';

import { useVerifyEmail } from "./useVerifyEmail";
import { useUserLogout } from '../../hooks/useUserLogout';

export interface IEmailVerificationPage {

}

const useStyles = makeStyles({
    backButton: {
        minWidth: "6px"
    },
    pageContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: "#F3F4F9"
    },
    backToLogin: {},
    text: {
    },
    email: {
        fontSize: "1.1rem !important",
        fontWeight: 600,
        color: "#212121 !important"

    },
    didntReceive: {
        "& span": {
            fontSize: "0.9rem",
            color: "#737FA4",
            padding: "0 3px",

        },
        "& a": {
            color: "#4F3CC9",
            fontSize: "0.9rem",
            textDecoration: "none",
            "&:visited": {
                color: "default"
            }
        }
    },
    resend: {
    },
    buttonWrapper: {
        margin: "24px 0"
    }
});


const EmailVerificationPage = (props: IEmailVerificationPage) => {
    const { isEmailVerified, isVerifyingEmail, emailAddress } = useVerifyEmail();
    const classes = useStyles();
    const history = useHistory();
    const { logout } = useUserLogout();
    const { t } = useTranslation();
    const [verificationComplete , setVerificationComplete] = useState(false);

    useEffect(() => {
        if(isEmailVerified && !isVerifyingEmail ){ 
            setVerificationComplete(true);
        }
    }, [isEmailVerified, isVerifyingEmail])

    return verificationComplete ? 
    <Redirect to={ANALYTICS_DASHBOARD_URL} />
    :(
        <div className={classes.pageContainer}>
            <HomeLayout>
                <div>
                    <div className={classes.backToLogin}>
                        <Button 
                            classes={{root: classes.backButton}}
                            onClick={logout}
                            style={{
                                padding: "8px",
                                marginRight: "8px"
                            }}
                            variant={'outlined'}
                        >
                           <ChevronLeft /> 
                        </Button>
                        {t("signup.verification.back_to_login")}
                    </div>
                    <EmailVerificationMessage emailAddress={emailAddress}/>
                    <div className={classes.buttonWrapper}>
                        <Button 
                            style={{padding: "12px"}}
                            variant={'contained'} 
                            color={'primary'} 
                            fullWidth
                            onClick={() => {
                                history.push(SQUARE_SIGNUP_URL)
                            }} 
                        >
                            {t("signup.verification.different_email")}
                        </Button>
                    </div>
                    
                </div>          
            </HomeLayout>
        </div>
        
        
    )
}

export default EmailVerificationPage;